import type { AgentComponentListItem } from '@reach/shared-types/agent-components';
import type { AgentTemplateKind } from '@reach/shared-types/agents';
import { Link } from 'react-router-dom';
import { componentPath } from '../agent-component-paths';
import { LIST_COPY, TEMPLATE_KIND_NAMES } from '../agents-copy';
import { ModeBadge } from '../ModeBadge';
import { ComponentRowActions } from './ComponentRowActions';
import styles from './ComponentRow.module.css';

interface ComponentRowProps {
  component: AgentComponentListItem;
}

const TEMPLATE_KIND_ORDER = Object.keys(TEMPLATE_KIND_NAMES) as AgentTemplateKind[];

const describeToolCount = (toolDefinitionIds: string[]): string => {
  const componentHasTools = toolDefinitionIds.length > 0;
  return componentHasTools ? LIST_COPY.toolCount(toolDefinitionIds.length) : LIST_COPY.noTools;
};

const describeTemplateKinds = (templateKinds: AgentTemplateKind[]): string => {
  const componentIsUsed = templateKinds.length > 0;
  if (!componentIsUsed) {
    return LIST_COPY.notUsed;
  }
  return TEMPLATE_KIND_ORDER.filter(kind => templateKinds.includes(kind))
    .map(kind => TEMPLATE_KIND_NAMES[kind])
    .join(' · ');
};

export const ComponentRow = ({ component }: ComponentRowProps) => {
  const { id, type, name, description, mode, templateKinds } = component;

  return (
    <tr className={styles.row}>
      <th scope="row">
        <Link to={componentPath(type, id)}>{name}</Link>
        {description && <p>{description}</p>}
      </th>
      {'toolDefinitionIds' in component && <td>{describeToolCount(component.toolDefinitionIds)}</td>}
      <td>{describeTemplateKinds(templateKinds)}</td>
      <td>
        <ModeBadge mode={mode} />
      </td>
      <td className={styles.actions}>
        <ComponentRowActions component={component} />
      </td>
    </tr>
  );
};
